(function() {
    'use strict';

    function CreateWidget() {
        this.$featuresDesktopSlider = $('.create-features-slider--desktop');
        this.$featuresTabletSliders = $('.create-features-slider--tablet');

        this.init();
    }

    CreateWidget.prototype.init = function() {
        new window.FeaturesSlider(this.$featuresDesktopSlider, {
            isDesktop: true
        });

        this.$featuresTabletSliders.each(function() {
            new window.FeaturesSlider($(this));
        });
    };

    window.apps = window.apps || {};
    window.apps.CreateWidget = CreateWidget;
})();



// WEBPACK FOOTER //
// ./assets/js/projects/apps/widgets/create.js